"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSUPPORTED_INSURANCE_PRODUCTS = exports.SUPPORTED_INSURANCE_PRODUCTS = exports.InsuranceProducts = exports.InsuranceProduct = void 0;
var InsuranceProduct;
(function (InsuranceProduct) {
    InsuranceProduct["AssuranceActive"] = "AssuranceActive";
    InsuranceProduct["AssuranceAdvanced"] = "AssuranceAdvanced";
    InsuranceProduct["AssuranceBalanced"] = "AssuranceBalanced";
    InsuranceProduct["AssuranceConnect"] = "AssuranceConnect";
    InsuranceProduct["AssuranceElite"] = "AssuranceElite";
    InsuranceProduct["AssuranceProtect"] = "AssuranceProtect";
    InsuranceProduct["AssuranceSelect"] = "AssuranceSelect";
    InsuranceProduct["ConsumerProtect"] = "ConsumerProtect";
    InsuranceProduct["WorldWide"] = "WorldWide";
    InsuranceProduct["HSP"] = "HSP";
    InsuranceProduct["CP"] = "CP";
    InsuranceProduct["WW"] = "WW";
    InsuranceProduct["AY"] = "AY";
    InsuranceProduct["AZ"] = "AZ";
    InsuranceProduct["BY"] = "BY";
    InsuranceProduct["BZ"] = "BZ";
    InsuranceProduct["CY"] = "CY";
    InsuranceProduct["CZ"] = "CZ";
    InsuranceProduct["EZ"] = "EZ";
    InsuranceProduct["PY"] = "PY";
    InsuranceProduct["PZ"] = "PZ";
    InsuranceProduct["AN"] = "AN";
    InsuranceProduct["AV"] = "AV";
})(InsuranceProduct = exports.InsuranceProduct || (exports.InsuranceProduct = {}));
exports.InsuranceProducts = Object.values(InsuranceProduct);
exports.SUPPORTED_INSURANCE_PRODUCTS = [
    InsuranceProduct.AssuranceElite,
    InsuranceProduct.AssuranceActive,
    InsuranceProduct.AssuranceBalanced,
    InsuranceProduct.AssuranceProtect,
];
exports.UNSUPPORTED_INSURANCE_PRODUCTS = [
    ...exports.InsuranceProducts.filter(p => !exports.SUPPORTED_INSURANCE_PRODUCTS.includes(p)),
];
//# sourceMappingURL=insurance-product.js.map